// Change Variant Image
function variantImage() {
  var imageURLs = document.querySelectorAll("[data-src]");
  imageURLs.forEach(function (element) {
    element.addEventListener("click", function () {
      var getURL = element.getAttribute("data-src");
      var mainImage = element.closest(".product-card-wrapper").querySelector(".card__media .media img");
      var variantLength = element.closest('.product-card-wrapper').querySelectorAll('.variant-list li').length;
      if(variantLength > 1) {
        mainImage.setAttribute("srcset", getURL);
      }
    });
  });
}
variantImage();
// Change Variant Image	

// Active Current Variant & Change Variant Price
function variantPrice() {
  const variantName = document.querySelectorAll(".product-card-wrapper .variant_name");
  const variantSelect = document.querySelectorAll(".variant_size");

  variantName.forEach((option) => {
    option.addEventListener("click", function () {
      const productCard = option.closest(".product-card-wrapper");
      const variantID = option.getAttribute("variant_id");
      const actualPrice = option.getAttribute("actual_price");
      const comparePrice = option.getAttribute("compareprice");
      const salePrice = productCard.querySelector(".price__sale .price-item--sale");
      const actualComparePrice = productCard.querySelector(".price__sale .product_compare_price");
      

if (option.classList.contains('not_available')) {
  var $cardWrapper = option.closest('.card-wrapper');
  var $classAdd = $cardWrapper.querySelector('.quick-add__submit');
  var $getBtn = $cardWrapper.querySelector('.add_to_cart_btn');
  
  // console.log("getbtn 77777777777777777777777",this)
  $getBtn.innerText = 'SOLD OUT';
  $classAdd.classList.add('sold_out');
  $classAdd.setAttribute('disabled', true);
} else {
  var $cardWrapper = option.closest('.card-wrapper');
  var $getBtn = $cardWrapper.querySelector('.cstm_add_to_cart');
  var $classAdd = $cardWrapper.querySelector('form .quick-add__submit');
  
  $getBtn.innerText = 'ADD TO CART';
  $classAdd.classList.remove('sold_out');
  $classAdd.removeAttribute('disabled');
}

function preventClickOnHello(event) {
  if ($(event.target).hasClass('sold_out')) {
    // event.preventDefault();
  }
}      
if(variantName.length > 1) {
  if (salePrice) salePrice.innerText = actualPrice;
}else {
  if (salePrice) salePrice.innerText = actualPrice;
}
if (actualComparePrice) {
actualComparePrice.innerText = comparePrice;
}
const changeValue = productCard.querySelector("product-form .product-variant-id");
if (changeValue) changeValue.setAttribute("value", variantID);
});
});

variantSelect.forEach(function (e) {
  e.addEventListener("click", function () {
    let selectedVariant = this.closest(".variant-list").querySelectorAll(".variant_size");
    selectedVariant.forEach(function (e) {
      e.classList.remove("active-variant");
    });
    this.classList.add("active-variant");
  });
});
variantImage();
}
variantPrice();



window.variantpriceChange = variantPrice;
window.variantimageChange = variantImage